import React from 'react';
import Translate, {t} from "../../../../../../../components/Translate";
import {silverInfoStyles} from "../../../../../../../utils/General";
import {
    updateAiContentLoadingHours,
    updateAiHumanOnlyHours,
    updateAiType
} from "../../../../../../../services/company/api";
import config from "../../../../../../../config";
import Input from "../../../../../../../components-new/Input";

const AiConfigs = ({
                       setAiType,
                       aiType,
                       features,
                       user,
                       client,
                       aiDescription,
                       handleAiDescriptionChange,
                       handleSaveAiDescription,
                       aiContentLoadingHours,
                       setAiContentLoadingHours,
                       aiHumanOnlyHours,
                       setAiHumanOnlyHours
                   }) => {
    return (
        <div style={{
            padding: '10px',
            margin: '20px auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            maxWidth: '800px',
        }}>
            <h2 className="configurations-header">
                <Translate text="configsAI"/>
            </h2>

            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
                width: '100%',
                padding: '10px'
            }}>

                <div style={{
                    padding: '10px',
                    borderRadius: '10px',
                    backgroundColor: '#fff'
                }}>
                    <h2 style={{...silverInfoStyles.info, marginLeft: '0px'}}>
                        <Translate text="aiType"/>
                    </h2>
                    <select
                        onChange={(e) => {
                            const value = e.target.value;
                            updateAiType(client.id, value).then(() => setAiType(value));
                        }}
                        value={aiType ? aiType : "null"}
                        style={{
                            display: 'block',
                            width: '100%',
                            marginTop: '10px',
                            backgroundColor: 'white',
                            border: '1px solid rgb(221, 221, 221)',
                            fontSize: '16px',
                            padding: '10px',
                            borderRadius: '10px',
                            marginBottom: '10px',
                        }}
                    >
                        <option value="null">{t({text: "notSelected", user})}</option>
                        {features.includes(config.features.GPT_AI) && (
                            <option value={config.AITypes.GPT_AI}>
                                {t({text: config.AITypes.GPT_AI, user})}
                            </option>
                        )}
                        {features.includes(config.features.TEAM_AI) && (
                            <option value={config.AITypes.TEAM_AI}>
                                {t({text: config.AITypes.TEAM_AI, user})}
                            </option>
                        )}
                    </select>
                </div>

                {(aiType === config.AITypes.GPT_AI || aiType === config.AITypes.TEAM_AI) && (
                    <div style={{
                        padding: '10px',
                        borderRadius: '10px',
                        backgroundColor: '#fff',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <h2 style={{...silverInfoStyles.info, marginLeft: '0px', marginBottom: '5px'}}>
                            <Translate text="AIExplanation"/>
                        </h2>
                        <Input
                            isTextarea={true}
                            placeholder={t({text: "aiDescriptionExample", user})}
                            value={aiDescription}
                            onChange={handleAiDescriptionChange}
                            style={{marginBottom: '5px'}}
                            onBlur={handleSaveAiDescription}
                        />
                    </div>
                )}

                {(aiType === config.AITypes.GPT_AI || aiType === config.AITypes.TEAM_AI) && (
                    <div style={{
                        padding: '10px',
                        borderRadius: '10px',
                        backgroundColor: '#fff',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <h2 style={{...silverInfoStyles.info, marginLeft: '0px', marginBottom: '5px'}}>
                            <Translate text="aiContentLoadingHoursExpl"/>
                        </h2>
                        <Input
                            min={0}
                            max={10000}
                            style={{width: '10%'}}
                            type={'number'}
                            value={aiContentLoadingHours}
                            onChange={(e) => setAiContentLoadingHours(e.target.value)}
                            onBlur={(e) => {
                                const value = e.target.value;
                                if (value) updateAiContentLoadingHours(client.id, value).then(() => setAiContentLoadingHours(value));
                            }}
                        />
                    </div>
                )}

                {(aiType === config.AITypes.GPT_AI || aiType === config.AITypes.TEAM_AI) && (
                    <div style={{
                        padding: '10px',
                        borderRadius: '10px',
                        backgroundColor: '#fff',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <h2 style={{...silverInfoStyles.info, marginLeft: '0px', marginBottom: '5px'}}>
                            <Translate text="aiHumanOnlyHoursExpl"/>
                        </h2>
                        <Input
                            min={0}
                            max={10000}
                            style={{width: '10%'}}
                            type={'number'}
                            value={aiHumanOnlyHours}
                            onChange={(e) => setAiHumanOnlyHours(e.target.value)}
                            onBlur={(e) => {
                                const value = e.target.value;
                                if (value) updateAiHumanOnlyHours(client.id, value).then(() => setAiHumanOnlyHours(value));
                            }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default AiConfigs;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/configurations/AIConfigs.jsx